const students = {
  all_students: 'All Students',
  label: 'students',
  create: 'Create New Student',
  active: 'Active',
  inactive: 'Inactive',
  firstname: 'Name',
  lastname: 'Parent Surname',
  lastname2nd: 'Mother Surname',
  course: 'Course',
  courses: 'Courses',
  school: 'School',
  only_independent: 'Independent only',
  independent: 'Independent',
  independent_notice: 'Independent student: no school or course, and none can be assigned.',
  diagnostics_not_applicable: 'Diagnostic: not applicable to independent students.',
  student_grade: 'Student grade',
  grade_option_0: 'Kindergarten',
  grade_option_n: 'Grade {grade}',
  state: 'State',
  edit: 'edit',
  username: 'Username',
  register_date: 'Registered',
  section: 'Section',
  sections: 'Sections',
  select_section: 'Section',
  select_courses: 'Select Courses',
  general_information: 'Student Information',
  email: 'Email',
  last_access: 'Last access',
  without_last_access: 'Without access',
  create_new_information: '🔑 New password',
  creation_date: 'Creation',
  dni: 'Identification',
  student_name: 'Student Name',
  student_parent_lastname: 'Parent Lastname',
  student_mother_lastname: 'Mother Lastname',
  birthdate: 'Birth Date',
  country: 'Country',
  select_country: 'Select Country',
  grade: 'Grade',
  grades: 'Grades',
  select_grade: 'Select grade',
  select_school: 'Select School',
  section_required: 'Section is required',
  dni_required: 'Identification is required',
  dni_length_valid: 'The minimum length for the identification is 8 characters',
  dni_with_blank_spaces: 'DNI cointains blank spaces',
  firstname_required: 'Name is required',
  lastname_required: 'The father\'s last name is required',
  lastname2nd_required: 'Mother\'s surname is required',
  birthDate_required: 'Date of birth is required',
  country_required: 'Country is required',
  school_required: 'School is required',
  grade_required: 'Grade is required',
  new_password_was_set: 'Password set successfully',
  new_password_not_saved: 'Password could not be saved',
  student_not_found: 'Student not found',
  load_partial_error: 'Could not load all the student information. Please try again.',
  users_updated: 'Users successfully updated',
  user_saved: 'User successfully saved',
  impersonate: 'Impersonate',
  impersonate_opening: 'Opening session as',
  impersonate_choose_app: 'Go to Teachers app? Cancel opens DataSystem.',
  users_disabled: '🚫 Student(s) disabled correctly.',
  users_enabled: '✅ Student(s) enabled correctly.',
  action_error: '⚠️ Something went wrong! Try to perform this same action later.',
  disable_user_btn: 'Disable Student(s)',
  enable_user_btn: 'Enable Student(s)',
  email_invalid: 'Invalid email',
  birth_date: 'Birth date',
  generate_username: 'Generate username?',
  dni_invalid: 'Check the DNI format or whitespace',
  select_country_first: 'Select a country first',
  select_school_first: 'Select a school first',
  created_title: 'Student created',
  created_credentials: 'Username: {username} · Initial password: {password}',
  created_must_change: 'The student must change the password on first login.',
  create_another: 'Create another',
  create_error: 'Could not create the student. Please try again.',
  dni_exists: 'The DNI or username already exists',
  create_independent: 'Create independent student',
  lastname_single: 'Last name',
  email_optional: 'Email (optional)',
  grade_optional: 'Grade (optional)',
  grade_optional_hint: 'If left empty, the student picks it when signing in.',
  time_zone_optional: 'Time zone (optional)',
  independent_copy_warning: 'Copy the username and password now: they will not be shown again.',
  independent_forbidden: 'You do not have permission to create independent students. Only a Beeverso admin can do it.',
  independent_invalid: 'Check the form: one of the values is not valid (for example, the time zone).',
};

export default students;
